export default "__VITE_ASSET__B$aHk6Fb__"